import request, { IWorkspaceResponse } from '/@/api/http/request'
import XRequest from '/@/api/http/Xrequest '
/** 分页查询三维模型 */
export const getPageModel = (params:{
  'page': number,
  'pageSize': number,
  'param': {
    'modelCode': string,
    'modelName': string,
    'status': string,
    'fileType': string,
    'projectId': string,
    'projectIds': string[]
  }
}) => {
  return request.post('/service/business/model3d/page', params)
}

/** 获取登录人模型文件夹树 */
export const getModelFolderTree = async (params?:any):Promise<IWorkspaceResponse<any>> => {
  const url = '/business/modelfolder/tree-by-login-user'
  const result = await XRequest.get(url, { params })
  return result.data
}

// 根据文件夹id获取对应的模型
export async function getModelsByFolderId (folderId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/business/modelfolder/get-detail-by-folder-id/${folderId}`
  const result = await XRequest.get(url)
  return result.data
}
